module.exports = __webpack_public_path__ + "img/phone.6ebf0810.svg";